/**
 * Eventin calendar/list – format price: zł3490 -> 3490 zł brutto
 */
const PRICE_SELECTOR = ".etn-event-price";
const FORMATTED_ATTR = "data-g2l-price-formatted";

function formatPricePart(raw) {
    const text = raw.trim();

    if (!text || /\bbrutto\b/i.test(text)) {
        return text;
    }

    const match = text.match(/^(?:zł|PLN)?\s*([\d\s.,]+)(?:\s*(?:zł|PLN))?$/i);

    if (!match) {
        return text;
    }

    const amount = match[1].trim();

    return `${amount} zł brutto`;
}

function formatPriceElement(el) {
    if (el.getAttribute(FORMATTED_ATTR) === "1") {
        return;
    }

    const original = el.textContent.trim();

    if (!original) {
        return;
    }

    if (original.includes("-")) {
        const parts = original.split("-").map((part) => formatPricePart(part));

        el.textContent = parts.join(" - ");
        el.setAttribute(FORMATTED_ATTR, "1");

        return;
    }

    const formatted = formatPricePart(original);

    if (formatted !== original) {
        el.textContent = formatted;
        el.setAttribute(FORMATTED_ATTR, "1");
    }
}

function formatAllPrices(root = document) {
    root.querySelectorAll(PRICE_SELECTOR).forEach(formatPriceElement);
}

function initEventinPrices() {
    formatAllPrices();

    const roots = document.querySelectorAll(
        ".eventin-shortcode-wrapper, .etn-event-wrapper",
    );

    if (!roots.length) {
        return;
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) {
                    return;
                }

                if (node.matches(PRICE_SELECTOR)) {
                    formatPriceElement(node);
                }

                formatAllPrices(node);
            });
        });
    });

    roots.forEach((root) => {
        observer.observe(root, { childList: true, subtree: true });
    });
}

document.addEventListener("DOMContentLoaded", initEventinPrices);
